/**
 * Global Spinner Component used in SCI
 */

// components
import { FullPageLoader } from '@makemydeal/dr-sales-checkin-components';
import { useCommonSelector } from '@makemydeal/dr-sales-checkin-store';

// selectors

const SalesCheckInGlobalSpinner: React.FC = () => {
    const commonState = useCommonSelector();
    const showSpinner = commonState.globalSpinnerCount;

    if (!showSpinner) {
        return <></>;
    }

    return <FullPageLoader message={commonState.globalSpinnerMessage} />;
};

export default SalesCheckInGlobalSpinner;
